export default "__VITE_ASSET__DE_Ovj8i__"